<template>
  <section class="bg-default section-md">
    <div class="container">
      УПС. НЕТ ТАКОЙ СТРАНИЦЫ.
    </div>
  </section>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {

    }
  },
  name: "Page404E",
  created() {

  },
  methods: {

  },
  computed: {

  }
};
</script>
